import { render } from "./product_item.vue?vue&type=template&id=77ee5d32&scoped=true"
import script from "./product_item.vue?vue&type=script&lang=js"
export * from "./product_item.vue?vue&type=script&lang=js"

import "./product_item.vue?vue&type=style&index=0&id=77ee5d32&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ee5d32"]])

export default __exports__